'use strict';

var _defineProperty = require("/app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var opentracing = require('opentracing');

var Tracer = opentracing.Tracer;
var Reference = opentracing.Reference;

var Span = require('./span');

var SpanContext = require('./span_context');

var SpanProcessor = require('../span_processor');

var Sampler = require('../sampler');

var PrioritySampler = require('../priority_sampler');

var TextMapPropagator = require('./propagation/text_map');

var HttpPropagator = require('./propagation/http');

var BinaryPropagator = require('./propagation/binary');

var LogPropagator = require('./propagation/log');

var NoopSpan = require('../noop/span');

var formats = require('../../../../ext/formats');

var log = require('../log');

var constants = require('../constants');

var platform = require('../platform');

var REFERENCE_NOOP = constants.REFERENCE_NOOP;
var REFERENCE_CHILD_OF = opentracing.REFERENCE_CHILD_OF;
var REFERENCE_FOLLOWS_FROM = opentracing.REFERENCE_FOLLOWS_FROM;

var DatadogTracer =
/*#__PURE__*/
function (_Tracer) {
  _inherits(DatadogTracer, _Tracer);

  function DatadogTracer(config) {
    var _this$_propagators;

    var _this;

    _classCallCheck(this, DatadogTracer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatadogTracer).call(this));
    var Exporter = platform.exporter(config.experimental.exporter);
    _this._service = config.service;
    _this._version = config.version;
    _this._env = config.env;
    _this._tags = config.tags;
    _this._logInjection = config.logInjection;
    _this._analytics = config.analytics;
    _this._debug = config.debug;
    _this._prioritySampler = new PrioritySampler(config.env, config.experimental.sampler);
    _this._exporter = new Exporter(config, _this._prioritySampler);
    _this._processor = new SpanProcessor(_this._exporter, _this._prioritySampler);
    _this._url = _this._exporter._url;
    _this._sampler = new Sampler(config.sampleRate);
    _this._peers = config.experimental.peers;
    _this._propagators = (_this$_propagators = {}, _defineProperty(_this$_propagators, formats.TEXT_MAP, new TextMapPropagator(config)), _defineProperty(_this$_propagators, formats.HTTP_HEADERS, new HttpPropagator(config)), _defineProperty(_this$_propagators, formats.BINARY, new BinaryPropagator(config)), _defineProperty(_this$_propagators, formats.LOG, new LogPropagator(config)), _this$_propagators);

    if (config.reportHostname) {
      _this._hostname = platform.hostname();
    }

    return _this;
  }

  _createClass(DatadogTracer, [{
    key: "startSpan",
    value: function startSpan(name, fields) {
      if (fields) {
        if (fields.references) {
          return _get(_getPrototypeOf(DatadogTracer.prototype), "startSpan", this).call(this, name, fields);
        } else if (fields.childOf) {
          var parent = fields.childOf;

          if (parent instanceof Span) {
            parent = parent.context();
          }

          if (parent instanceof SpanContext) {
            return this._startSpanInternal(name, fields, parent, REFERENCE_CHILD_OF);
          }
        }
      }

      return this._startSpanInternal(name, fields, null, null);
    }
  }, {
    key: "_startSpan",
    value: function _startSpan(name, fields) {
      var reference = getParent(fields.references);
      var type = reference && reference.type();
      var parent = reference && reference.referencedContext();
      return this._startSpanInternal(name, fields, parent, type);
    }
  }, {
    key: "_startSpanInternal",
    value: function _startSpanInternal(name) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var parent = arguments.length > 2 ? arguments[2] : undefined;
      var type = arguments.length > 3 ? arguments[3] : undefined;
      if (parent && parent._noop) return parent._noop;
      if (!isSampled(this._sampler, parent, type)) return new NoopSpan(this, parent);
      var tags = {
        'service.name': this._service
      };
      var span = new Span(this, this._processor, this._sampler, this._prioritySampler, {
        operationName: fields.operationName || name,
        parent: parent,
        tags: tags,
        startTime: fields.startTime,
        hostname: this._hostname
      }, this._debug);
      span.addTags(this._tags);
      span.addTags(fields.tags);
      span.addTags(platform.tags());
      return span;
    }
  }, {
    key: "_inject",
    value: function _inject(spanContext, format, carrier) {
      try {
        this._prioritySampler.sample(spanContext);

        this._propagators[format].inject(spanContext, carrier);
      } catch (e) {
        log.error(e);
        platform.metrics().increment('datadog.tracer.node.inject.errors', true);
      }

      return this;
    }
  }, {
    key: "_extract",
    value: function _extract(format, carrier) {
      try {
        return this._propagators[format].extract(carrier);
      } catch (e) {
        log.error(e);
        platform.metrics().increment('datadog.tracer.node.extract.errors', true);
        return null;
      }
    }
  }]);

  return DatadogTracer;
}(Tracer);

function getParent() {
  var references = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var parent = null;

  var _loop2 = function _loop2(i) {
    var ref = references[i];

    if (!(ref instanceof Reference)) {
      log.error(function () {
        return "Expected ".concat(ref, " to be an instance of opentracing.Reference");
      });
      return "continue";
    }

    var spanContext = ref.referencedContext();
    var type = ref.type();

    if (type !== REFERENCE_NOOP && spanContext && !(spanContext instanceof SpanContext)) {
      log.error(function () {
        return "Expected ".concat(spanContext, " to be an instance of SpanContext");
      });
      return "continue";
    }

    if (type === REFERENCE_CHILD_OF || type === REFERENCE_NOOP) {
      parent = ref;
      return "break";
    } else if (type === REFERENCE_FOLLOWS_FROM) {
      if (!parent) {
        parent = ref;
      }
    }
  };

  _loop: for (var i = 0; i < references.length; i++) {
    var _ret = _loop2(i);

    switch (_ret) {
      case "continue":
        continue;

      case "break":
        break _loop;
    }
  }

  return parent;
}

function isSampled(sampler, parent, type) {
  if (type === REFERENCE_NOOP) return false;
  if (parent && !parent._traceFlags.sampled) return false;
  if (!parent && !sampler.isSampled()) return false;
  return true;
}

module.exports = DatadogTracer;